import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import GuestList from "./pages/GuestList";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/avant-premiere-VIP" replace />} />
          <Route path="/avant-premiere-VIP" element={<Home />} />
          <Route path="/guest-list" element={<GuestList />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;